// extracted by mini-css-extract-plugin
export default {"itemTitle":"MqzkdfNtefjzXp6fDkPM"};